
import "./bordered-text.sass";
const BorderedText = ({ text, classes }) => {
  return <p data-testid="border-text" className={`bordered-text ${classes}`}>{text}</p>;
};

export default BorderedText;
